module.exports = __webpack_public_path__ + "static/media/treneri.73b878a5.jpg";